module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/6th/mainvisual-bg_2ae147e53df35f20cc0661d174bff187.svg";